import { PureComponent } from "react";
import ThemeableAgGrid from "../../common/components/agGrid/ThemeableAgGrid";
import { withTranslation } from "react-i18next";

class AlbertaEnvironmentalRegistryTable extends PureComponent {
  columnDefsCache = null;

  mappedRegistryCache = {
    registry: null,
    value: [],
  };

  // Define column definitions using the getColumnDefs method
  getColumnDefs() {
    const { t } = this.props;

    if (this.columnDefsCache?.t === t) {
      return this.columnDefsCache.value;
    }

    const columnDefs = [
      {
        field: "ProjectIdentifier",
        headerName: t("ProjectIdentifier"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "CurrentOwner",
        headerName: t("CurrentOwner"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "EmissionOffsetProjectDeveloper",
        headerName: t("EmissionOffsetProjectDeveloper"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Quantity",
        headerName: t("Quantity"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Registry",
        headerName: t("Registry"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Vintage",
        headerName: t("Vintage"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "QuantificationProtocol",
        headerName: t("QuantificationProtocol"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "ActivityStart",
        headerName: t("ActivityStart"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "ComplianceYear",
        headerName: t("ComplianceYear"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "ExpiryDate",
        headerName: t("ExpiryDate"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Facility",
        headerName: t("Facility"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "OffsetStartDate",
        headerName: t("OffsetStartDate"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "OffsetEndDate",
        headerName: t("OffsetEndDate"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Status",
        headerName: t("Status"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Title",
        headerName: t("Title"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "VerifierCompany",
        headerName: t("VerifierCompany"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "SerialStart",
        headerName: t("SerialStart"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "SerialEnd",
        headerName: t("SerialEnd"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "TransactionId",
        headerName: t("TransactionId"),
        filter: false,
        floatingFilter: false,
      },
    ];

    this.columnDefsCache = { t, value: columnDefs };
    return columnDefs;
  }

  mapToViewModel(registry) {
    if (this.mappedRegistryCache.registry === registry) {
      return this.mappedRegistryCache.value;
    }

    const mappedRegistry = registry.map((record, index) => ({
      index: index,
      ProjectIdentifier: record.ProjectIdentifier,
      CurrentOwner: record.CurrentOwner,
      EmissionOffsetProjectDeveloper: record.EmissionOffsetProjectDeveloper,
      Quantity: record.Quantity,
      Registry: record.Registry,
      Vintage: record.Vintage,
      QuantificationProtocol: record.QuantificationProtocol,
      ActivityStart: record._activityStartDisplay,
      ComplianceYear: record.ComplianceYear,
      ExpiryDate: record._expiryDateDisplay,
      Facility: record.Facility,
      OffsetStartDate: record._offsetStartDateDisplay,
      OffsetEndDate: record._offsetEndDateDisplay,
      Status: record.Status,
      Title: record.Title,
      VerifierCompany: record.VerifierCompany,
      SerialStart: record.SerialStart,
      SerialEnd: record.SerialEnd,
      TransactionId: record.TransactionId,
    }));

    this.mappedRegistryCache = {
      registry,
      value: mappedRegistry,
    };

    return mappedRegistry;
  }

  render() {
    const { registry, onRowClick } = this.props;

    const mappedRegistry = this.mapToViewModel(registry);
    const columnDefs = this.getColumnDefs();

    // Pagination configuration
    const paginationConfig = {
      // Enable pagination for all tables regardless of size
      enabled: true,
      // Default page size
      pageSize: 20,
      // Available page size options for user to choose
      pageSizeOptions: [5, 10, 20, 50, 100],
    };

    return (
      <ThemeableAgGrid
        className="table-extra-small"
        columnDefs={columnDefs}
        rowData={mappedRegistry}
        onRowClicked={(params) => onRowClick && onRowClick(params.data)}
        getRowId={(params) => String(params.data.index)}
        pagination={true}
        paginationPageSize={paginationConfig.pageSize}
        paginationPageSizeSelector={paginationConfig.pageSizeOptions}
        suppressPaginationPanel={false}
        allowHorizontalScroll={false}
      />
    );
  }
}

export default withTranslation(["marketdata"])(
  AlbertaEnvironmentalRegistryTable
);
